<template>
  <section class="reset-password-section">
    <!--<h3 class="mb-4">Reset Password</h3>-->
    <b-form data-vv-scope="resetPassword" v-if="show">
      <b-form-group
        id="input-group-1"
        label="New Password"
        label-for="input-1"
        description=" "
      >
        <b-form-input
          id="input-1"
          v-model="form.password"
          type="password"
          placeholder="********"
          v-validate="'required|min:8'"
          :class="{ 'is-invalid': errors.has('resetPassword.password') }"
          ref="password"
          name="password"
        ></b-form-input>
        <b-form-invalid-feedback id="input-3-live-feedback">
          <small>{{ errors.first("resetPassword.password") }}</small>
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        id="input-group-2"
        label="Re-Enter Password"
        label-for="input-2"
      >
        <b-form-input
          id="input-2"
          v-model="form.confirm_password"
          type="password"
          placeholder="********"
          v-validate="'required|confirmed:password'"
          :class="{
            'is-invalid': errors.has('resetPassword.confirm password')
          }"
          name="confirm password"
        ></b-form-input>
        <b-form-invalid-feedback id="confirm_password-feedback">
          <small>{{ errors.first("resetPassword.confirm password") }}</small>
        </b-form-invalid-feedback>
      </b-form-group>
      <div style="text-align: right">
        <b-button
          type="submit"
          variant="primary"
          @click.prevent="action('resetPassword')"
          >Reset</b-button
        >
      </div>
      <!--    <b-button type="reset" variant="danger">Reset</b-button>-->
    </b-form>
  </section>
</template>

<script>
import { authenticationApi } from "../services/authenticationApi";

export default {
  name: "ResetPassword",
  data() {
    return {
      form: {
        password: "",
        confirm_password: "",
        token: ""
      },
      showReset: false,
      show: true
    };
  },
  methods: {
    action(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result) {
          this.showReset = false;
          this.resetPassword();
        } else {
          this.showReset = true;
        }
      });
    },
    resetPassword() {
      this.form.token = this.$route.params.token;
      authenticationApi
        .resetPassword(this.form)
        .then(res => {
          this.$bvToast.toast(`Password changed successfully`, {
            title: "Reset Password",
            autoHideDelay: 500,
            appendToast: true
          });
          setTimeout(() => {
            this.$router.push("/");
          }, 500);
        })
        .catch(e => {
          this.$bvToast.toast(`Password Reset Failed ${e.body.message}`, {
            title: "Reset Password",
            autoHideDelay: 500,
            appendToast: true
          });
          this.resetForm();
        });
    },
    resetForm() {
      this.form.password = "";
      this.form.confirm_password = "";
      this.form.token = "";
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }
  }
};
</script>

<style scoped></style>
